import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { User } from "src/app/shared/models";
import { Team } from "src/app/shared/models/team";
import { UserTeamBusinessUnit } from "src/app/shared/models/user-trigger-business-unit";

@Injectable({
  providedIn: "root",
})
export class UserTeamBusinessUnitService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}UserTeamBusinessUnit`;

  public getAllUsers(id: number): Observable<User[]> {
    return this.http.get<User[]>(`${this.apiRoot}/getAllUsersByTeamId/${id}`);
  }

  public getAllUsersByTeamId(teamId: number): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByTeamId/${teamId}`
    );
  }

  public getAllUsersByBusinessUnit(businessUnit: string): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByBusinessUnit/${businessUnit}`
    );
  }

  public getAllUsersByBuId(buId: number): Observable<User[]> {
    return this.http.get<User[]>(
      `${this.apiRoot}/getAllUsersByBusinessUnitId/${buId}`
    );
  }

  public getAllTeamApprovers(userId: number): Observable<Team[]> {
    return this.http.get<Team[]>(
      `${this.apiRoot}/getAllTeamApprovers/${userId}`
    );
  }

  public getAllTeamApproversByUserIdAndBusinessUnitId(
    userId: number,
    businessUnitId: number
  ): Observable<Team[]> {
    return this.http.get<Team[]>(
      `${this.apiRoot}/getAllTeamApproversByUserIdAndBusinessUnitId/${userId}/${businessUnitId}`
    );
  }

  public getAllTeamApproversByUniqueKey(uniqueKey: string): Observable<Team[]> {
    return this.http.get<Team[]>(
      `${this.apiRoot}/getAllTeamApproversByUniqueKey/${uniqueKey}`
    );
  }

  // Deprecated
  // public createUserTeamBusinessUnit(userId: number, teamId: number, businessUnitId: number): Observable<UserTeamBusinessUnit>{
  //   const endPoint = `${this.apiRoot}/createUserTeamBusinessUnit`
  //   const body = {userId, teamId, businessUnitId};
  //   return this.http.post<UserTeamBusinessUnit>(endPoint, body);
  // }

  public createUserTeamBusinessUnit(
    triggerCode: string,
    uniqueKey: string,
    businessUnitCode: string
  ): Observable<HttpResponse<UserTeamBusinessUnit>> {
    const endPoint = `${this.apiRoot}/createUserTeamBusinessUnitV2`;
    const body = { triggerCode, uniqueKey, businessUnitCode };
    return this.http.post<UserTeamBusinessUnit>(endPoint, body, {
      observe: "response",
    });
  }

  public deleteUserTeamBusinessUnit(
    uniqueKey: string,
    team: string,
    businessUnit: string
  ) {
    const endPoint = `${this.apiRoot}/deleteUserTeamBusinessUnit/uniqueKey=${uniqueKey}/team=${team}/businessUnit=${businessUnit}`;
    return this.http.delete(endPoint);
  }
}
